// Careers Block JavaScript

(function($) {
	'use strict';

	// Initialize careers block functionality
	function initCareers() {
		$('.career-listing').on('click', function(e) {
			// Don't trigger if clicking on a link directly
			if ($(e.target).is('a') || $(e.target).closest('a').length) {
				return;
			}

			var url = $(this).data('job-url');
			if (url) {
				window.open(url, '_blank', 'noopener,noreferrer');
			}
		});

		// Add cursor pointer style
		$('.career-listing').css('cursor', 'pointer');
	}

	$(document).ready(function() {
		initCareers();
	});

})(jQuery);
